import { Box } from "@mui/material";
import { useState, useCallback } from "react";
import SingleSelectSearch from "@/modules/common/components/input/single-autocomplete-search";
import { Track } from "@/modules/property-tracks/types";

interface AssignedUserOption {
  value: string;
  label: string;
  color: string;
}

interface EditTrackAssignedUserProps {
  assignedUser: {
    handleChangeAssignedUser: (value: string) => void;
    data: any;
    value: string | undefined;
    usersSearchTerm: string;
    setUsersSearchTerm: (value: string) => void;
    usersLoading: boolean;
  };
  track: Track | undefined;
  autoFocus?: boolean;
}

const EditTrackAssignedUser = ({
  assignedUser,
  track,
}: EditTrackAssignedUserProps) => {
  const [selectedUserId, setSelectedUserId] = useState<string | undefined>(
    assignedUser.value || track?.user?.uid
  );

  const options: AssignedUserOption[] =
    assignedUser.data?.map(
      (option: {
        id: string;
        name: string;
        color: string;
        tags?: string[];
        configuration?: { isAvailable?: boolean };
      }) => {
        const label = option.name;
        const color = option.color;

        return {
          label,
          color,
          value: option.id,
        };
      }
    ) || [];

  const handleChange = useCallback(
    (value: string | null) => {
      setSelectedUserId(value ?? undefined);
      assignedUser.handleChangeAssignedUser(value ?? "");
    },
    [assignedUser]
  );

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <SingleSelectSearch
        options={options}
        isLoading={assignedUser.usersLoading}
        label="Assigned User"
        value={selectedUserId}
        onValueChange={handleChange}
        searchValue={assignedUser.usersSearchTerm}
        onSearchValueChange={assignedUser.setUsersSearchTerm}
      />
    </Box>
  );
};

export default EditTrackAssignedUser;
